import { render, staticRenderFns } from "./mobile-input-text.vue?vue&type=template&id=6267e1d0&scoped=true&"
import script from "./mobile-input-text.vue?vue&type=script&lang=ts&"
export * from "./mobile-input-text.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-input-text.vue?vue&type=style&index=0&id=6267e1d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6267e1d0",
  null
  
)

export default component.exports